import gql from "graphql-tag"

export const CART_WARNING_FRAGMENT = gql`
  fragment CartWarningFragment on CartWarning {
    code
    message
    target
  }
`
